import { DayOneIngressWidgetSma } from '@amzn/atozmobile-tenant-day-one-info/dist/components/DayOneIngressWidgetSma/DayOneIngressWidgetSma';
import React from 'react';
export var DayOneIngressWidget = function () {
    return React.createElement(DayOneIngressWidgetSma, null);
};
